import { TFile, TUploadFileArg } from 'data/types/storage.types';
import { EStorageUrls } from 'data/urls/storage.url';

import { authSplitApi } from '../helpers/slice.helpers';

export const storageApi = authSplitApi('storage', ['files']).injectEndpoints({
  endpoints: build => ({
    uploadFile: build.mutation<TFile, TUploadFileArg>({
      query({ file }) {
        return {
          url: `${EStorageUrls.STORAGE}/${EStorageUrls.FILES}`,
          method: 'POST',
          body: file,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useUploadFileMutation } = storageApi;
